import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';
import Header from '../layout/Header';
import { updateDevicesRequest, setFilterIp } from '../reducers/devices';
import {
  Box,
  MenuItem,
  TextField,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Table,
  withStyles
} from '@material-ui/core';

const styles = (theme) => ({
  main: {
    flexGrow: 1,
    padding: theme.spacing(2)
  },
  paper: {
    width: '100%',
    overflowX: 'auto',
    position: 'relative'
  },
  table: {
    minWidth: 650
  },
  title: {
    padding: theme.spacing(2, 0, 0, 2)
  },
  filterBox: {
    position: 'absolute',
    top: '12px',
    right: '12px'
  }
});

class Dashboard extends React.Component {
  componentDidMount() {
    updateDevicesRequest(this.props.filterIp);
  }

  componentDidUpdate(prevProps) {
    const { devices } = this.props;

    if (prevProps.filterIp !== this.props.filterIp) {
      updateDevicesRequest(this.props.filterIp);
    }

    if (devices === null) {
      setTimeout(updateDevicesRequest(devices), 1000);
    }
  }

  handleFilterChange = (event) => {
    const value = event.target.value;
    this.props.dispatch(setFilterIp(value));
  };

  render() {
    const { classes, devices, filterIp } = this.props;
    return (
      <div>
        <Header />
        <main className={classes.main}>
          <Paper className={classes.paper}>
            <Box className={classes.filterBox}>
              <TextField
                select
                value={filterIp}
                onChange={this.handleFilterChange}
                variant="outlined"
                size="small"
                style={{ minWidth: '150px' }}
              >
                <MenuItem value={true}>My devices</MenuItem>
                <MenuItem value={false}>All devices</MenuItem>
              </TextField>
            </Box>
            <Typography variant="h6" className={classes.title}>
              Online devices
            </Typography>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Serial number</TableCell>
                  <TableCell>Model</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {devices !== null &&
                  devices.map((device) => (
                    <TableRow key={device.device_id}>
                      <TableCell component="th" scope="row">
                        <Link
                          component={RouterLink}
                          to={`/device/${device.device_id}`}
                        >
                          {device.serial_number}
                        </Link>
                      </TableCell>
                      <TableCell>{device.model}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Paper>
        </main>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  isTokenRefreshing: state.auth.isTokenRefreshing,
  devices: state.devices.devices,
  filterIp: state.devices.filterIp
});

export default connect(mapStateToProps)(withStyles(styles)(Dashboard));
